// GA4 loader — dormant until REACT_APP_GA4_MEASUREMENT_ID is set. Never pass personal data to these helpers.
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let loaded = false;

export const initAnalytics = () => {
  if (!GA_ID || loaded || typeof window === 'undefined') return;
  loaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false, anonymize_ip: true });
};

export const trackPageView = (path) => {
  if (!GA_ID) return;
  initAnalytics();
  window.gtag?.('event', 'page_view', { page_path: path, page_location: window.location.href, page_title: document.title });
};

export const trackEvent = (name, params = {}) => {
  if (!GA_ID) return;
  initAnalytics();
  window.gtag?.('event', name, params);
};
